<template>
    <div class="loader">
      <lottie-player src="/animations/new-brand-loader.json" autoplay loop class="margin-bottom-m"
                     preserveAspectRatio="xMidYMax slice"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import router from '@/router';
import Segment from '@/Segment';
import _ from 'lodash';

export default {
  name: 'AdvisoryPlanRouting',
  created() {
    const utmParams = _.pickBy(router.currentRoute.query, (value, key) => (key.startsWith('utm_') && value));
    Segment.trackUserInteraction('AdvisoryPlanRouting_Entered', { ...utmParams });
    if (this.showAdvisorySingleMenuBanner) {
      this.redirectToAdvisorySingle();
    } else {
      this.redirectToWaitingList();
    }
  },
  computed: {
    ...mapGetters('featureFlags', ['showAdvisorySingleMenuBanner']),
  },
  methods: {
    redirectToAdvisorySingle() {
      Segment.trackUserInteraction('AdvisoryPlanRouting_RedirectToAdvisorySingle');
      router.push({ path: '/advisory-onboarding', query: { utm_source: 'plan-routing' } });
    },
    redirectToWaitingList() {
      Segment.trackUserInteraction('AdvisoryPlanRouting_RedirectToAdvisoryWaitingList');
      window.location.href = 'https://riseupisrael.typeform.com/to/lWU4V2Ss';
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
